package com.vizio.redwolf.auth.model

import io.ktor.http.HttpMethod

data class Endpoint(val url: String, val httpMethod: HttpMethod)